/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { IndividualPaymentRenegotiationViewModel } from "../types/IndividualPaymentRenegotiationViewModel.ts";
import { individualPaymentRenegotiationParcelViewModelSchema } from "./individualPaymentRenegotiationParcelViewModelSchema.ts";

export const individualPaymentRenegotiationViewModelSchema = z.object({
  courseRegistrationCompany: z.number().int().nullish(),
  courseRegistrationId: z.optional(z.number().int()),
  personId: z.optional(z.number().int()),
  personName: z.string().nullish(),
  courseName: z.string().nullish(),
  classStudentName: z.string().nullish(),
  courseFinancialId: z.optional(z.number().int()),
  courseFinancialPersonId: z.optional(z.number().int()),
  numberParcels: z.optional(z.number().int()),
  discountPunctualPercentage: z.optional(z.number()),
  totalValue: z.optional(z.number()),
  parcelValue: z.optional(z.number()),
  paymentMethod: z.optional(z.number().int()),
  observation: z.string().nullish(),
  blockOverdueInstallments: z.optional(z.boolean()),
  paymentDate: z.string().datetime().nullish(),
  customInstruction: z.string().nullish(),
  fractionOfParcel: z.number().nullish(),
  automaticAcceptance: z.optional(z.boolean()),
  parcels: z
    .array(z.lazy(() => individualPaymentRenegotiationParcelViewModelSchema))
    .nullish(),
}) as unknown as ToZod<IndividualPaymentRenegotiationViewModel>;
